// AWS Amplify Configuration
import { Capacitor } from '@capacitor/core';

const isNativeIOS = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_y1vbCZXp8',
      userPoolClientId: '4k8pla6vnreod5juntft88h7ta',
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        oauth: {
          domain: 'zealgenesis.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: isNativeIOS
            ? ['https://zealgenesis.com/']
            : ['https://zealgenesis.com/', 'https://localhost/'],
          redirectSignOut: isNativeIOS
            ? ['https://zealgenesis.com/']
            : ['https://zealgenesis.com/', 'https://localhost/'],
          responseType: 'code' as const,
          providers: ['Apple' as const],
        },
      },
    },
  },
};
